export default __webpack_public_path__ + "static/media/29.5e5b174e.png";